var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("side-panel", {
    directives: [
      {
        name: "show",
        rawName: "v-show",
        value: _vm.visible,
        expression: "visible"
      }
    ],
    attrs: { loading: _vm.loading },
    on: {
      close: function($event) {
        return _vm.$emit("update:visible", false)
      }
    },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function() {
          return [
            _c("h3", { staticClass: "mt-0 clearfix" }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$l10n.__("Ajouter une remise TTC")) +
                  "\n        "
              )
            ])
          ]
        },
        proxy: true
      },
      {
        key: "content",
        fn: function() {
          return [
            _c(
              "el-form",
              {
                ref: "docBonusForm",
                attrs: {
                  "label-position": "top",
                  model: _vm.docBonus,
                  "inline-message": true,
                  "label-width": "120px"
                }
              },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t.__("documents.DocBonusForm.discount"),
                      prop: "bonus",
                      error: _vm.errors.get("bonus")
                    }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        on: { change: _vm.changeBonus },
                        model: {
                          value: _vm.docBonus.bonus,
                          callback: function($$v) {
                            _vm.$set(_vm.docBonus, "bonus", $$v)
                          },
                          expression: "docBonus.bonus"
                        }
                      },
                      _vm._l(_vm.bonuses, function(option) {
                        return _c("el-option", {
                          key: option.id,
                          attrs: { label: option.ref, value: option.id }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.chosenBonus
                  ? _c(
                      "div",
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t.__("common.labels.name"),
                              prop: "name",
                              error: _vm.errors.get("name")
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                value: _vm.chosenBonus.name,
                                readonly: "readonly",
                                disabled: true
                              },
                              model: {
                                value: _vm.chosenBonus.name,
                                callback: function($$v) {
                                  _vm.$set(_vm.chosenBonus, "name", $$v)
                                },
                                expression: "chosenBonus.name"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t.__("common.labels.amount"),
                              prop: "amount",
                              error: _vm.errors.get("montant")
                            }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "flex-row" },
                              [
                                _c("input-number", {
                                  key: _vm.docBonus.amount,
                                  attrs: {
                                    controls: false,
                                    precision: _vm.numberFormat.precision,
                                    "separator-decimal":
                                      _vm.numberFormat.decimal,
                                    "separator-thousand":
                                      _vm.numberFormat.thousand
                                  },
                                  model: {
                                    value: _vm.docBonus.amount,
                                    callback: function($$v) {
                                      _vm.$set(_vm.docBonus, "amount", $$v)
                                    },
                                    expression: "docBonus.amount"
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "input-addon append ml-2",
                                    staticStyle: {
                                      height: "32px",
                                      "box-sizing": "border-box",
                                      "padding-top": "10px",
                                      "white-space": "nowrap"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                            / " +
                                        _vm._s(_vm.chosenBonus.formatted_unit) +
                                        "\n                        "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t.__("common.labels.quantity"),
                      prop: "qty",
                      error: _vm.errors.get("qty")
                    }
                  },
                  [
                    _c("input-number", {
                      attrs: {
                        value: _vm.docBonus.qty,
                        controls: false,
                        precision: _vm.numberFormat.precision,
                        "separator-decimal": _vm.numberFormat.decimal,
                        "separator-thousand": _vm.numberFormat.thousand
                      },
                      model: {
                        value: _vm.docBonus.qty,
                        callback: function($$v) {
                          _vm.$set(_vm.docBonus, "qty", $$v)
                        },
                        expression: "docBonus.qty"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.chosenBonus
                  ? _c("div", { staticClass: "form-group" }, [
                      _c(
                        "label",
                        {
                          staticClass: "form-label bold label-block",
                          attrs: { for: "" }
                        },
                        [_vm._v(_vm._s(_vm.$l10n.__("Total")))]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-input span_12" }, [
                        _c("input", {
                          staticClass: "span_12 h-4",
                          attrs: {
                            type: "text",
                            readonly: "readonly",
                            disabled: true
                          },
                          domProps: {
                            value: _vm.$filters.numberFormat(_vm.totalBonus)
                          }
                        })
                      ])
                    ])
                  : _vm._e()
              ],
              1
            )
          ]
        },
        proxy: true
      },
      {
        key: "footer",
        fn: function() {
          return [
            _c("CompassButton", {
              attrs: {
                label: _vm.$t.__("common.actions.save"),
                disabled: _vm.docBonus.bonus == ""
              },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.save($event)
                }
              }
            })
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }